import {
    BaseType,
    BuildComponentType,
    CardinalDirection, ColorEnum,
    ElevatorType, HazardousState, HazardType, LevelType,
    Material,
    RiskConstructionType, RoofShape, RoomType,
    UtilityCategory, WindowPaneType
} from "./Enums";

export const translateOther = (key: string | undefined): string => {
    if (key === undefined) {
        return 'Odefinierat'
    }

    const translations: { [key: string]: string } = {
        roof: "Tak",
        facade: "Fasad",
        foundation: "Grund",
        drainage: "Avvattning",
        chimney: "Skorsten/murstock",

        asbestos: "Asbest",
        led: "Bly",
        pcb: "PCB",
        arsenic: "Arsenik",
        blueConcrete: "Blåbetong",
        radon: "Radon",

        SUSPECTED: "Misstänkt",
        CONFIRMED: "Bekräftat",
    };

    return translations[key] || key;
};

type TranslateableValue = Material | UtilityCategory | CardinalDirection | BuildComponentType | RiskConstructionType |
    ElevatorType | ColorEnum | HazardType | RoofShape | RoomType | HazardousState | WindowPaneType | LevelType |
    BaseType
    ;

type ExhaustiveCheck<T extends string | number> = {
    [K in T]: string;
};

export function translate(value: TranslateableValue | undefined | string): string {
    if (value === undefined) {
        return "Odefinierat"
    }

    const translations: ExhaustiveCheck<TranslateableValue> = {
        [Material.Wood]: "Trä",
        [Material.Brick]: "Tegel",
        [Material.SheetMetal]: "Plåt",
        [Material.Render]: "Puts",
        [Material.RenderThick]: "Tjock puts",
        [Material.RenderThin]: "Tunn puts <10mm",
        [Material.Concrete]: "Betong",
        [Material.LightweightConcrete]: "Lättbetong",
        [Material.Granite]: "Granit",
        [Material.Aluminum]: "Aluminium",
        [Material.Pvc]: "PVC",
        [Material.CementBoard]: "Cementbaserad skiva",
        [Material.MetalWorksOnFacade]: "Plåtarbeten på fasad",
        [Material.Leca]: "Leca",
        [Material.Steel]: "Stål",
        [Material.CorrugatedMetal]: "Korrugerad plåt",
        [Material.FiberCement]: "Fibercement",
        [Material.RolledSheetMetal]: "Valsad plåt",
        [Material.RoofingFelt]: "Takpapp",
        [Material.Sedum]: "Sedum",
        [Material.SoilLayer]: "Jordlager",
        [Material.ConcreteCastInPlace]: "Betong platsgjuten",
        [Material.ConcretePrecast]: "Betong prefab",
        [Material.WoodGlulam]: "Limträ",
        [Material.WoodPrefab]: "Trä Prefab",
        [Material.StructuralTimber]: "Konstruktionsvirke",
        [Material.AsbestosCement]: "Eternit",
        [Material.OrganicMaterial]: "Organiskt växtmaterial",
        [Material.SteelDecking]: "Bärande plåt",
        [Material.Stone]: "Sten",
        [Material.Composite]: "Komposit",
        [Material.Gravel]: "Grus",
        [Material.Metal]: "Plåt",
        [Material.Grass]: "Gräs",
        [Material.Plastic]: "Plast",
        [Material.ConcretePainted]: "Målad betong",
        [Material.Drywall]: "Gips",
        [Material.DrywallPainted]: "Målad gips",
        [Material.DrywallWallpaper]: "Tapetserad gips",
        [Material.WoodPanelPainted]: "Målad träpanel",
        [Material.WoodPanelBare]: "Trären panel",
        [Material.RenderPainted]: "Målad puts",
        [Material.CeramicTiles]: "Kakel",
        [Material.FloorTiles]: "Klinker",
        [Material.FloorCarpet]: "Golvmatta textil",
        [Material.FloorLaminate]: "Laminat",
        [Material.FloorVinyl]: "Golvmatta plast",
        [Material.FloorParquet]: "Parkettgolv",
        [Material.AcousticTiles]: "Akustikplattor",
        [Material.DropTiles]: "Nedpendlat undertak",
        [Material.Plywood]: "Plywood",

        [UtilityCategory.Ventilation]: "Ventilation",
        [UtilityCategory.HeatingCooling]: "Värme/kyla",
        [UtilityCategory.Elevator]: "Hiss",
        [UtilityCategory.FireSafety]: "Brandskydd",
        [UtilityCategory.MechanicalMaintenanceRiskConstructions]: "",
        [UtilityCategory.Electrical]: "",
        [UtilityCategory.WaterAndSewage]: "",
        [UtilityCategory.DoorAutomation]: "",

        [CardinalDirection.North]: "Nord",
        [CardinalDirection.NorthEast]: "Nordost",
        [CardinalDirection.East]: "Öst",
        [CardinalDirection.SouthEast]: "Sydöst",
        [CardinalDirection.South]: "Syd",
        [CardinalDirection.SouthWest]: "Sydväst",
        [CardinalDirection.West]: "Väst",
        [CardinalDirection.NorthWest]: "Nordväst",

        [BuildComponentType.FacadeVerticalSiding]: "Stående panel",
        [BuildComponentType.FacadeHorizontalSiding]: "Liggande panel",
        [BuildComponentType.FacadeCavityWall]: "Skalmur",
        [BuildComponentType.FacadeRender]: "Puts >10mm",
        [BuildComponentType.FacadeThinRender]: "Tunnputs <10mm",
        [BuildComponentType.FacadePlinth]: "Sockel",
        [BuildComponentType.FacadeSandwichPanel]: "Sandwichpanel",
        [BuildComponentType.FacadeCorrugatedMetal]: "Korrigerad plåt",

        [BuildComponentType.Geotechnics]: "Geoteknik",

        [BuildComponentType.FoundationGroundSlab]: "Platta på mark",
        [BuildComponentType.FoundationCrawlSpace]: "Krypgrund",
        [BuildComponentType.FoundationSlopingSite]: "Sutteräng-grundläggning",
        [BuildComponentType.FoundationCellar]: "Källargrundläggning",
        [BuildComponentType.FoundationPile]: "Pålgrundläggning",
        [BuildComponentType.FoundationPier]: "Plintgrundläggning",
        [BuildComponentType.FoundationWallOnFooting]: "Grundmur på sula",
        [BuildComponentType.FoundationBlindingLayer]: "Rustbädd",
        [BuildComponentType.FoundationRaisedFloor]: "Plintgrund",

        [BuildComponentType.ChimneyStack]: "Murstock",
        [BuildComponentType.ChimneyFlue]: "Skorstenskanal",
        [BuildComponentType.ChimneyCap]: "Skorstenshuv",

        [BuildComponentType.RoofCorrugatedMetal]: "Korrugerad plåt",
        [BuildComponentType.RoofFiberCement]: "Fibercement",
        [BuildComponentType.RoofRolledSheetMetal]: "Valsad plåt",
        [BuildComponentType.RoofFelt]: "Papp",
        [BuildComponentType.RoofSedum]: "Sedumtak",
        [BuildComponentType.RoofBrick]: "Tegelpannor",
        [BuildComponentType.RoofConcrete]: "Betongpannor",

        [BuildComponentType.DrainageDrainpipe]: "Stuprör",
        [BuildComponentType.DrainageGutter]: "Hängränna",

        [BuildComponentType.WindowWood]: "Träfönster",
        [BuildComponentType.WindowAluminium]: "Aluminiumfönster",
        [BuildComponentType.WindowPvc]: "PVC-fönster",

        [BuildComponentType.StructuralStudWallInterior]: "Regelvägg innervägg",
        [BuildComponentType.StructuralStudWallExterior]: "Regelvägg yttervägg",
        [BuildComponentType.StructuralSandwichInterior]: "Sandwich innervägg",
        [BuildComponentType.StructuralSandwichExterior]: "Sandwich yttervägg",
        [BuildComponentType.StructuralSolidWallInterior]: "Massiv innervägg",
        [BuildComponentType.StructuralSolidWallExterior]: "Massiv yttervägg",
        [BuildComponentType.StructuralPanelsInterior]: "Väggskivor innervägg",
        [BuildComponentType.StructuralPanelsExterior]: "Väggskivor yttervägg",
        [BuildComponentType.StructuralConcreteWall]: "Betongvägg",
        [BuildComponentType.StructuralBrickWall]: "Tegelvägg",
        [BuildComponentType.StructuralMasonryWall]: "Murverk",
        [BuildComponentType.StructuralLightweightConcreteWall]: "Lättbetongvägg",


        [BuildComponentType.StructuralColumnInFacade]: "Pelare i fasad",
        [BuildComponentType.StructuralColumnInteriorWall]: "Pelare i innervägg",
        [BuildComponentType.StructuralButtress]: "Kontrefor",
        [BuildComponentType.StructuralExposedBeam]: "Synliga fria balkar",
        [BuildComponentType.StructuralConcealedBeam]: "Inbyggda balkar",

        [BuildComponentType.StructuralFloorWoodBeam]: "Träbalkar i bjälklag",
        [BuildComponentType.StructuralFloorSteelBeam]: "Stålbalkar i bjälklag",
        [BuildComponentType.StructuralFloorConcreteBeam]: "Betongbalkar i bjälklag",
        [BuildComponentType.StructuralFloorSolidSlab]: "Massivbjälklag",

        [BuildComponentType.StructuralRoofBeam]: "Takbalkar",
        [BuildComponentType.StructuralRoofTruss]: "Takstolar",
        [BuildComponentType.StructuralRoofLightweightConcreteElement]: "Lättbetongelement",
        [BuildComponentType.StructuralRoofCassettes]: "Takkassetter",
        [BuildComponentType.StructuralRoofMetalSheetTrp]: "Takplåt TRP",
        [BuildComponentType.StructuralRoofConcrete]: "Betong",

        [BuildComponentType.OutdoorTerrace]: "Altan",
        [BuildComponentType.OutdoorPavedArea]: "Plattlagd yta",
        [BuildComponentType.OutdoorPavement]: "Gång/trottoar",
        [BuildComponentType.OutdoorWoodenFence]: "Trästaket",
        [BuildComponentType.OutdoorWoodenPlank]: "Träplank",
        [BuildComponentType.OutdoorStoneWall]: "Mur",
        [BuildComponentType.OutdoorGrassArea]: "Gräs",
        [BuildComponentType.OutdoorParkingGravel]: "Grusparkering",
        [BuildComponentType.OutdoorParkingAsphalt]: "Asfaltsparkering",
        [BuildComponentType.OutdoorPavedAreaStone]: "Hårdgjord yta sten",
        [BuildComponentType.OutdoorPavedAreaAsphalt]: "Hårdgjord yta asfalt",
        [BuildComponentType.OutdoorPermanentFurniture]: "Permanenta möbler",
        [BuildComponentType.OutdoorPlayground]: "Lekplats",
        [BuildComponentType.OutdoorSwingSet]: "Gungställning",
        [BuildComponentType.OutdoorSandbox]: "Sandlåda",
        [BuildComponentType.OutdoorSlide]: "Rutschkana",
        [BuildComponentType.OutdoorOther]: "Övrigt",

        [BuildComponentType.InteriorWall]: "Innervägg",
        [BuildComponentType.InteriorCeiling]: "Innertak",
        [BuildComponentType.InteriorFloor]: "Innergolv",

        [BuildComponentType.UtilityGeothermalHeatPumpEarth]: "Jordvärmepump",
        [BuildComponentType.UtilityGeothermalHeatPumpBedrock]: "Bergvärmepump",
        [BuildComponentType.UtilityElectricBoiler]: "Elpanna",
        [BuildComponentType.UtilityPelletBoiler]: "Pelletsvärmepanna",
        [BuildComponentType.UtilityWoodBoiler]: "Vedpanna",
        [BuildComponentType.UtilityAirToAirHeatPump]: "Luftvärmepump (luft-luft)",
        [BuildComponentType.UtilityAirToWaterHeatPump]: "Luftvärmepump (luft/vatten)",
        [BuildComponentType.UtilityAirConditioning]: "AC",
        [BuildComponentType.UtilityDistrictCooling]: "Fjärrkyla",
        [BuildComponentType.UtilityPoolHeating]: "Poolvärme",

        [BuildComponentType.UtilitySVentilation]: "S-ventilation: Självdragsventilation",
        [BuildComponentType.UtilityFVentilation]: "F-ventilation: Fläktventilation frånluft",
        [BuildComponentType.UtilityFtVentilation]: "FT-ventilation: Fläktventilation till- och frånluft",
        [BuildComponentType.UtilityFxVentilation]: "FX-ventilation: F-ventilation med värmeåtervinning",
        [BuildComponentType.UtilityFtxVentilation]: "FTX-ventilation: FT-ventilation med värmeåtervinnning",

        [BuildComponentType.UtilityPassengerElevator]: "Personhiss",
        [BuildComponentType.UtilityFreightElevator]: "Varu/transport-hiss",

        [BuildComponentType.UtilitySmokeDetector]: "Brandvarnare",
        [BuildComponentType.UtilityFireAlarm]: "Brandlarm",
        [BuildComponentType.UtilityFireBlanket]: "Brandfilt",
        [BuildComponentType.UtilityFireExtinguisher]: "Brandsläckare",
        [BuildComponentType.UtilitySprinkler]: "Sprinkler",
        [BuildComponentType.UtilityFireControlPanel]: "Brandcentral",

        [BuildComponentType.UtilityMechanicalDehumidification]: "Mekanisk avfuktning",
        [BuildComponentType.UtilityRadonExtractor]: "Radonsug",
        [BuildComponentType.UtilityVentilatedFloorUnit]: "Ventilerade golv - aggregat",
        [BuildComponentType.UtilitySorptionDehumidification]: "Sorptionsavfuktning",
        [BuildComponentType.UtilitySafetyGuardSystem]: "Trygghetsvakt",

        [BuildComponentType.UtilityElectricMainSwitchboard]: "Huvudcentral",
        [BuildComponentType.UtilityElectricSubSwitchboard]: "Undercentral",

        [RiskConstructionType.RiskCrawlSpace]: "Krypgrund",
        [RiskConstructionType.RiskSingleStageSealedRender]: "Enstegstätad putsfasad (utan luftspalt)",
        [RiskConstructionType.RiskFloatingFloor]: "Flytande golv",
        [RiskConstructionType.RiskUninsulatedSlabOnGround]: "Oisolerad platta på mark",
        [RiskConstructionType.RiskExternallyVentilatedAttic]: "Uteluftsventilerad vind",
        [RiskConstructionType.RiskCompactRoofNoAirGap]: "Kompakttak (utan luftspalt)",
        [RiskConstructionType.RiskInternalDrainage]: "Invändig avvattning",
        [RiskConstructionType.RiskLowSlopeRoof]: "Låglutande tak",
        [RiskConstructionType.RiskBuiltInWaterConnections]: "Dolda/inbyggda vattenkopplingar",
        [RiskConstructionType.RiskExternalWallNoVaporBarrier]: "Yttervägg utan diffusionsspärr",
        [RiskConstructionType.RiskUngroundedElectricalSystem]: "Ojordat elsystem",
        [RiskConstructionType.RiskCablesThroughExternalWallRoof]: "Kabelgenomföringar genom yttervägg och yttertak",

        [ElevatorType.TractionElevator]: "Linhiss",
        [ElevatorType.Stairlift]: "Trapphiss",
        [ElevatorType.HydraulicElevator]: "Hydraulisk hiss",

        [ColorEnum.ColorRed]: "Röd",
        [ColorEnum.ColorOrange]: "Orange",
        [ColorEnum.ColorYellow]: "Gul",
        [ColorEnum.ColorGreen]: "Grön",
        [ColorEnum.ColorBlue]: "Blå",
        [ColorEnum.ColorPurple]: "Lila",
        [ColorEnum.ColorPink]: "Rosa",
        [ColorEnum.ColorWhite]: "Vit",
        [ColorEnum.ColorBlack]: "Svart",
        [ColorEnum.ColorBrown]: "Brun",

        [HazardType.HazardAsbestos]: "Asbest",
        [HazardType.HazardLed]: "Bly",
        [HazardType.HazardPcb]: "PCB",
        [HazardType.HazardArsenic]: "Arsenik",
        [HazardType.HazardBlueConcrete]: "Blåbetong",
        [HazardType.HazardRadon]: "Radon",

        [RoofShape.RoofShapeGable]: "Sadeltak",
        [RoofShape.RoofShapeMansard]: "Mansardtak",
        [RoofShape.RoofShapeHip]: "Valmat tak",
        [RoofShape.RoofShapeShed]: "Pulpettak",
        [RoofShape.RoofShapeInvertedShed]: "Motfallstak",
        [RoofShape.RoofShapeCylindrical]: "Cylindriskt tak",
        [RoofShape.RoofShapeFlat]: "Flackt tak",

        [RoomType.RoomGeneral]: "Allmänt",
        [RoomType.RoomKitchen]: "Kök",
        [RoomType.RoomAssembly]: "Matsal/samlingshall",
        [RoomType.RoomOffice]: "Kontor",
        [RoomType.RoomBathroom]: "Badrum/toalett",
        [RoomType.RoomStorage]: "Förråd/förvaring",
        [RoomType.RoomUtility]: "Teknikrum",
        [RoomType.RoomEntryway]: "Hall",
        [RoomType.RoomHallway]: "Korridor",
        [RoomType.RoomChanging]: "Omklädningsrum",
        [RoomType.RoomWork]: "Arbetsrum",
        [RoomType.RoomConference]: "Konferens",
        [RoomType.RoomLecture]: "Föreläsning",
        [RoomType.RoomExhibit]: "Utställning",
        [RoomType.RoomWarmAttic]: "Varmvind",
        [RoomType.RoomColdAttic]: "Kallvind",

        [HazardousState.Suspected]: "Misstänkt",
        [HazardousState.Confirmed]: "Bekräftad",

        [WindowPaneType.OnePane]: "Enkelglas",
        [WindowPaneType.TwoPane]: "2-glas",
        [WindowPaneType.ThreePane]: "3-glas",

        [LevelType.Basement]: "Källare",
        [LevelType.GroundFloor]: "Bottenvåning",
        [LevelType.NthFloor]: "Våning",
        [LevelType.Attic]: "Vind",

        [BaseType.Ceiling]: "Innertak",
        [BaseType.Chimney]: "Skorsten/murstock",
        [BaseType.Drainage]: "Avvattning",
        [BaseType.Facade]: "Fasad",
        [BaseType.Floor]: "Golv",
        [BaseType.Foundation]: "Grund",
        [BaseType.GeoTechnics]: "Geoteknik",
        [BaseType.InteriorWall]: "Innervägg",
        [BaseType.Outdoor]: "Utomhusobjekt",
        [BaseType.Roof]: "Tak",
        [BaseType.StructuralColumnOrBeam]: "structural_column_or_beam",
        [BaseType.StructuralFloor]: "structural_floor",
        [BaseType.StructuralFoundation]: "structural_foundation",
        [BaseType.StructuralRoof]: "structural_roof",
        [BaseType.StructuralWall]: "structural_wall",
        [BaseType.Wall]: "Innervägg",
        [BaseType.Window]: "Fönster",
        [BaseType.Utility]: "Fastighetsteknik",

    } as const;

    const translationKey = value as keyof typeof translations;
    return translations[translationKey] ?? translationKey;
}
